interface AuthErrorLike {
  status?: number;
  code?: string;
  message?: string;
}

const RATE_LIMIT_CODES = ['over_request_rate_limit', 'over_email_send_rate_limit', 'over_sms_send_rate_limit'];

/**
 * Supabase Auth throttling ("For security purposes, you can only request this
 * after N seconds", HTTP 429). Expected user behaviour (double taps, retries),
 * so callers show a friendly message and log it as a warning, not an error.
 */
export function isAuthRateLimitError(error: unknown): boolean {
  if (typeof error !== 'object' || error === null) return false;
  const { status, code, message } = error as AuthErrorLike;

  if (status === 429) return true;
  if (code && RATE_LIMIT_CODES.includes(code)) return true;
  return /after \d+ seconds/i.test(message ?? '') || /rate limit/i.test(message ?? '');
}

export function isEmailTakenError(error: unknown): boolean {
  if (typeof error !== 'object' || error === null) return false;
  const message = ((error as AuthErrorLike).message ?? '').toLowerCase();
  return message.includes('already registered') || message.includes('user already exists');
}
